import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepBlockContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '30px',
  marginBottom: '30px',
  [theme.breakpoints.down('lg')]: {
    flexWrap: 'wrap',
    overflow: 'auto',
    justifyContent: 'flex-start',
    scrollSnapType: 'y mandatory',
    '-webkit-overflow-scrolling': 'touch',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
}));

export const StepColumn = styled(Box)(({ theme, stepcount }) => {
  const count = Number(stepcount) || 4;

  let flexBasis, maxWidth, minHeight, maxHeight;

  if (count === 1) {
    flexBasis = '45%';
    maxWidth = '200px';
    minHeight = '100%';
    maxHeight = '100%';
  } else if (count === 2) {
    flexBasis = '45%';
    maxWidth = '470px';
    minHeight = '300px';
    maxHeight = 'none';
  } else if (count === 3) {
    flexBasis = '32%';
    maxWidth = '240px';
    minHeight = '230px';
    maxHeight = 'none';
  } else {
    flexBasis = '24%';
    maxWidth = '200px';
    minHeight = '300px';
    maxHeight = 'none';
  }

  return {
    flex: `0 1 ${flexBasis}`,
    maxWidth: maxWidth,
    minWidth: '200px',
    minHeight: minHeight,
    maxHeight: maxHeight,
    borderRadius: '10px',
    padding: '16px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    backgroundColor: 'var(--brand-surface, #fff)',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
      maxWidth: '250px',
      minWidth: '250px',
    },
  };
});

export const StepTitle = styled(Typography)(({ theme, iscondensed }) => ({
  textAlign: 'center',
  fontWeight: 600,
  marginBottom: '12px',
  lineHeight: 1.2,
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  WebkitUserDrag: 'none',
  pointerEvents: 'auto',
  color: '#EE6D29',
  fontSize: iscondensed ? '22px' : '26px',

  [theme.breakpoints.down('sm')]: {
    minHeight: 'unset',
  },
}));

export const StepText = styled(Typography)`
  text-align: left;
  line-height: 1.5;
  color: var(--brand-text, #000);
  font-size: ${props => (props.iscondensed ? '18px' : '20px')};
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  /* Prevent drag */
  -webkit-user-drag: none;

  /* Disable context menu on right-click */
  pointer-events: auto;
`;
